import Message from "@/models/conversation/Message";
import { FC } from "react";
import { getMessageRatings } from "../helpers/UserConvOverviewHelper";

type UserConversationStatisticsProps = {
  messages: Message[];
  conversationTitle: string;
  filterComponent: React.ReactNode;
};

const UserConversationStatistics: FC<UserConversationStatisticsProps> = ({
  messages,
  conversationTitle,
  filterComponent,
}) => {
  const { average } = getMessageRatings(messages);
  const statisticsArray = [
    {
      title: "Total antal beskeder",
      value: messages.length,
    },
    {
      title: "Gennemsnitslige bedømmelser",
      value: average.toFixed(2),
    },
  ];

  return (
    <div className="flex flex-col justify-start bg-card rounded-lg shadow-md">
      <div className="flex flex-row px-4 py-2 border-b border-border justify-between">
        <div className="text-2xl font-bold">{conversationTitle}</div>
        {filterComponent}
      </div>
      <div className="flex flex-row justify-between">
        {statisticsArray.map((item) => (
          <div
            key={item.title}
            className="flex flex-row border-r-2 last:border-r-0 px-6 py-3 w-1/2 justify-between"
          >
            <div className="flex flex-col gap-2">
              <div className="text-md font-medium flex items-center gap-2">
                {item.title}
              </div>
              <div className="text-2xl font-bold">{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserConversationStatistics;
